import { makeAutoObservable } from "mobx";
import { NewsLetter } from "../types";
import { RootStore } from "./root.store";
import NewsLetterService from "../services/newsletter.service";

export class NewsLetterStore {
  rootStore: RootStore;
  data: NewsLetter[] = [];
  loaded: boolean = false;
  loading: boolean = false;
  error: string | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  async getAll(): Promise<NewsLetter[]> {
    this.data = [];
    this.loading = true;
    this.error = null;

    try {
      const response = await NewsLetterService.fetchAll({
        pageSize: 1000,
        pageNumber: 1,
      });
      this.data = response.data;
      this.loaded = true;
      return this.data as NewsLetter[];
    } catch (error: any) {
      const msg = error?.message || String(error);
      this.error = msg;
      console.error("Error fetching newsletter list:", msg);
      return [];
    } finally {
      this.loading = false;
    }
  }
}
